export default __webpack_public_path__ + "static/duke-0e6ae4cc3c38355318f12ff62c6e7a96.jpg";